import { get } from '.';

export function GetTicketCategories() {
	return get<any>('/app/api/ticket_categories');
}